import React from 'react';
import StatusLabel from '../Status/StatusLabel';
import { humaniseStatus } from './taskColumns';

/**
 * One status chip for both task queues.
 *
 * They each had their own before, and the two had drifted: AllTasks coloured
 * completed and rejected and left everything else grey, while TaskList coloured
 * nothing at all — so the same application showed a different chip depending on
 * which page you were looking at.
 *
 * `status` is the raw enum value, which is what carries the meaning. `label` is
 * the display text the endpoint already humanised ("Pending Legal Approval");
 * without one the raw value is humanised here.
 */
const StatusChip = ({ status, label }) => (
  <StatusLabel kind="application" status={status} label={label || humaniseStatus(status)} />
);

export default StatusChip;
